type RadioItemProps = {
  id: string;
  name: string;
  checked: boolean;
  onChange: () => void;
  children: React.ReactNode;
};

/** Rebrand radio button with its label in a bordered card that is clickable
 * all over ("Form/Form Item" in Figma), e.g. the sign-up location picker. */
export function RadioItem({
  id,
  name,
  checked,
  onChange,
  children,
}: RadioItemProps) {
  return (
    <label
      htmlFor={id}
      // font-normal: the provider app bolds every label.
      className="tw-m-0 tw-flex tw-cursor-pointer tw-items-center tw-gap-[16px] tw-rounded-[8px] tw-border tw-border-solid tw-border-verse-border-primary tw-bg-white tw-p-[16px] tw-font-sohne tw-text-[14px] tw-font-normal tw-leading-[1.4] tw-text-verse-text-primary"
    >
      <input
        id={id}
        type="radio"
        name={name}
        checked={checked}
        onChange={onChange}
        className="tw-m-0 tw-h-[16px] tw-w-[16px] tw-shrink-0 tw-cursor-pointer tw-accent-verse-tide"
      />
      <span>{children}</span>
    </label>
  );
}
